export default __webpack_public_path__ + "static/media/sort_icon.a53841e1.svg";